import { SCAttributes } from "../../common/generic/generic-sc-attributes";
import { SCKpis } from "../../common/generic/generic-sc-domain";
import { IGenericAggregateResponse } from "../../common/generic/generic-types";
import { Format } from "../../common/utils/format";
import { IVEByYearData, IVoicElecVM } from "./types";

const elecColor = "#444852";
const voiceColor = "#dc4941";

export function mapData(
  data: IGenericAggregateResponse
): [IVEByYearData[], number[]] {
  const chartData = [];
  const xData = [];
  const requestYear = Format.GetYear(data.request ? data.request.date : "");
  xData[0] = requestYear;
  xData[1] = requestYear - 1;
  const mappedData: IVEByYearData[] = [];

  const voiceElecData: IVoicElecVM = {
    Sc_Elec_ytd: 0,
    Sc_Elec_ytd_1: 0,
    Sc_voice_ytd: 0,
    Sc_voice_ytd_1: 0,
  };
  if (!data.aggregates || data.aggregates.length < 1) {
    return [mappedData, xData];
  }
  data.aggregates.forEach(aggregate => {
    switch (aggregate.dimensionAttributeValues[SCAttributes.SC_MARK_IS_ELEC]) {
      case "Y":
        voiceElecData.Sc_Elec_ytd = aggregate.indicatorKpiValues[SCKpis.SC_YTD];
        voiceElecData.Sc_Elec_ytd_1 =
          aggregate.indicatorKpiValues[SCKpis.SC_YTD_1];
        break;
      case "N":
        voiceElecData.Sc_voice_ytd =
          aggregate.indicatorKpiValues[SCKpis.SC_YTD];
        voiceElecData.Sc_voice_ytd_1 =
          aggregate.indicatorKpiValues[SCKpis.SC_YTD_1];
        break;
    }
  });

  mappedData.push({
    data: [
      Format.FormatNumber(voiceElecData.Sc_voice_ytd, 1000, 0),
      Format.FormatNumber(voiceElecData.Sc_voice_ytd_1, 1000, 0),
    ],
    name: "Voice",
  });

  mappedData.push({
    data: [
      Format.FormatNumber(voiceElecData.Sc_Elec_ytd, 1000, 0),
      Format.FormatNumber(voiceElecData.Sc_Elec_ytd_1, 1000, 0),
    ],
    name: "Elec",
  });

  return [mappedData, xData];
}

export function BuildStackBarChartOptions(mappedData: any) {
  return {
    chart: {
      type: "bar",
    },
    credits: {
      enabled: false,
    },
    legend: {
      reversed: true,
    },
    plotOptions: {
      series: {
        stacking: "percent",
      },
    },
    series: [
      {
        color: voiceColor,
        data: mappedData[0][0].data,
        name: mappedData[0][0].name,
      },
      {
        color: elecColor,
        data: mappedData[0][1].data,
        name: mappedData[0][1].name,
      },
    ],
    title: {
      text: "",
    },
    tooltip: {
      pointFormat:
        '<span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y:,.0f} K€</b> ({point.percentage:.0f}%)<br/>',
      shared: true,
    },
    xAxis: {
      categories: mappedData[1],
    },
    yAxis: {
      visible: false,
    },
  };
}
